<script setup lang="ts">
import {
  FETCH_MSG,
  UwuowoResultBundle,
  UwuowoPiece,
  UwuowoRegions,
} from "./UwuowoUtils";

import { computed } from "vue";
import { NUM_ADV_PIECES, PIECE_NAMES } from "@/Utils/Constants";
import LabeledPieceIcon from "../LabeledPieceIcon.vue";

const props = defineProps<{
  region: UwuowoRegions;
  char_name: string;
  apply: (_: UwuowoPiece[], force_t4: boolean, char_name?: string) => void;
  char_parsed: UwuowoResultBundle;
  close_on_success: boolean;
}>();

const emit = defineEmits<{
  show_popup: [new_state: boolean];
}>();

function confirm(force_t4: boolean) {
  if (props.close_on_success) {
    emit("show_popup", false);
  }

  props.apply(props.char_parsed.result.pieces, force_t4, props.char_name);
}
const have_both = computed(() => {
  return (
    props.char_parsed &&
    props.char_parsed.result &&
    props.char_parsed.result.pieces
      .slice(0, NUM_ADV_PIECES)
      .some((x) => x.tier === 1) &&
    props.char_parsed.result.pieces.some(
      (x) => x.tier === 0, //  && (x.plus_n < 20 || x.adv < 40),
    )
  );
});

const link = computed(
  () => `https://lostark.bible/character/${props.region}/${props.char_name}`,
);
</script>

<template>
  <div class="w-60 rounded-sm border border-(--border-muted) px-3 py-2">
    <div v-if="char_parsed.result" class="flex flex-col">
      <span>
        <a class="link text-2xl! font-bold" :href="link"
          >{{ props.char_name }}
        </a></span
      >

      <span> Region: {{ props.region }}</span>
      <span> Class: {{ char_parsed.result.class_name }} </span>
      <span class="pb-2 text-(--achieved)">
        Achieved ilevel: {{ char_parsed.result.achieved_ilevel }}</span
      >
      <div class="-ml-3 grid grid-cols-[max-content_1fr_1fr_1fr]">
        <div
          v-for="(piece, index) in PIECE_NAMES"
          :key="piece"
          class="contents"
        >
          <LabeledPieceIcon :piece="piece" />
          <div v-if="index < char_parsed.result.pieces.length" class="contents">
            <span class="px-1">
              {{
                char_parsed.result.pieces[index].tier === 0 ? "T4" : "Serca"
              }}</span
            >
            <span class="px-1">
              +{{ char_parsed.result.pieces[index].plus_n }}</span
            >
            <span class="px-1">{{
              isNaN(char_parsed.result.pieces[index].ilevel)
                ? ""
                : char_parsed.result.pieces[index].ilevel
            }}</span>
          </div>
          <div v-else>
            <span class="px-1"> N/A</span>
          </div>
        </div>
      </div>
    </div>
    <a
      :href="link"
      class="link"
      v-if="!char_parsed.result && char_parsed.status !== FETCH_MSG"
    >
      {{ link }}</a
    >

    <div v-if="have_both" class="flex w-full flex-col flex-wrap">
      <span>
        You seem to have both Serca gear and T4 gear. We cannot calculate the
        cost of upgrades from different tiers at the same time.
      </span>
      <span> Pick what tier you want to calculate: </span>
    </div>
    <div
      class="flex w-full pt-2"
      :class="have_both ? 'flex-col items-center' : 'flex-row justify-around'"
    >
      <button
        v-if="have_both"
        class="generic-button text-(--achieved)!"
        @click="() => confirm(true)"
      >
        Confirm (T4)
      </button>
      <div
        v-if="char_parsed.result && char_parsed.status !== FETCH_MSG"
        class="flex flex-row content-end"
      >
        <button
          class="generic-button text-(--achieved)!"
          @click="() => confirm(false)"
        >
          Confirm {{ have_both ? "(Serca)" : "" }}</button
        ><span
          v-if="have_both"
          class="w-0 basis-0 origin-right transform-[translateY(8px)] pl-px text-left text-xs text-(--text-very-muted)"
          >(default)</span
        >
      </div>
      <button
        @click="emit('show_popup', false)"
        class="generic-button bg-(--warning-dark)! text-(--text-bright)!"
        :class="{ 'order-first': !have_both }"
      >
        Cancel
      </button>
    </div>
  </div>
</template>
